import React, { useState, useEffect } from 'react';
import { inject, observer } from "mobx-react";
import Email from '@mui/icons-material/MailOutline';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import LocationOnSharpIcon from '@mui/icons-material/LocationOnSharp';

const FooterAddressMenu = ({ feathersStore }) => {
    const [settingsPhone, setSettingsPhone] = useState("");

    useEffect(() => {
        const phoneNumber = feathersStore.settings?.phoneNumbers?.find(p => p.numberEnabled)?.phoneNumber;
        setSettingsPhone(phoneNumber);
    }, [feathersStore.settings]);

    return (
        <div className="footer-contact-info">
            {settingsPhone && (
                <div className="footer-contact-row">
                    <AddIcCallIcon />
                    <a href={`tel:${settingsPhone}`} className="footer-contact-link">
                        {settingsPhone}
                    </a>
                </div>
            )}
            
            {feathersStore.settings?.email && (
                <div className="footer-contact-row">
                    <Email />
                    <span className="footer-contact-link">{feathersStore.settings.email}</span>
                </div>
            )}
            
            {feathersStore.settings?.latitude && feathersStore.settings?.longitude && (
                <div className="footer-contact-row">
                    <LocationOnSharpIcon />
                    <a
                        className="footer-contact-link"
                        href={`https://www.google.com/maps/search/?api=1&query=${feathersStore.settings.latitude},${feathersStore.settings.longitude}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {feathersStore._translateAddress()}
                    </a>
                </div>
            )}
        </div>
    );
};

export default inject('feathersStore')(observer(FooterAddressMenu));